import swal from 'sweetalert';

$('.cart-toggle').click(function(event) {
  $(this).parent('.cart-wrap').toggleClass('open');
  return false;
});
$(document).on('click', function(e){
  if($(e.target).parents('.cart-wrap').length==0){
    $('.cart-wrap').removeClass('open');
  }
});
$('.btn-favorite').click(function(event) {
  var btn = $(this);
  var pid = btn.data('pid');
  $.post(
    App.homeUrl+'/api/product/favorite',
    {
      _token: App.csrfToken,
      pid: pid,
    },
    function(response){
      if (response.active) {
        btn.find('.fa').attr('class', 'fa fa-heart')
      } else {
        btn.find('.fa').attr('class', 'fa fa-heart-o')
      }
    }
  ).fail(function(response) {
    // alertError(response.responseJSON.message)
  });
  return false;
});
// 商品切換規格
$(document).on('change', '[name^=option]', function() {
  var props = $('[name=pdid]').val().toString();
  var fillField = [];
  var fillFieldCount = 0;
  $('[name^=option]').each(function(index, value) {
    var optName = $(this).attr('name');
    if($.inArray(optName, fillField) == -1) {
      fillField.push(optName);
    }
  });
  $.each(fillField, function(index, value) {
    if($('[name="'+value+'"]').is('select')) {
      var field = $('[name="'+value+'"]');
      if (field.val()) {
        fillFieldCount ++;
        props += '-'+field.val().toString();
      }
    } else {
      var field = $('[name="'+value+'"]:checked');
      if (field.val()) {
        fillFieldCount ++;
        props += '-'+field.val().toString();
      }
    }
  });
  if (fillFieldCount == fillField.length) {
    $.post(
      App.homeUrl+'/api/cart/change_sku',
      {
        _token: App.csrfToken,
        props: props,
      },
      function(response){
        var infoHtml = '';
        infoHtml += '<li>商品編號：'+response.data.num+'</li>'
        // 目前價格不是原價的情況下，要顯示原價並加上刪除線
        if (response.priceType != 1) {
          infoHtml += '<li><del>'+App.priceType[1]+'：'+showPrice(response.data.price)+'</del></li>'
        }
        infoHtml += '<li>'
        infoHtml += App.priceType[response.priceType]+'：'+showPrice(response.price)
        if (response.priceType == 4) {
          $.each(response.data.product.discounts, function(index, discount) {
            infoHtml += ' <span class="alert alert-danger">('+discount.title+' '+discount.percent+'% off)</span>'
          })
        }
        infoHtml += '</li>'

        $('ul.product-info').html(infoHtml);
        if (response.data.qty<1) {
          $('.btn-add-cart, .input-num-group').hide();
          $('.btn-soldout').show();
        } else {
          $('.btn-add-cart, .input-num-group').show();
          $('.btn-soldout').hide();
        }
        // updateTopCart(data)
        // alertSuccess('商品成功加入購物車');
      }
    ).fail(function(response) {
      var infoHtml = '';
      infoHtml += '<li>'+response.responseJSON.message+'</li>'
      $('ul.product-info').html(infoHtml);
      $('.btn-add-cart, .input-num-group').hide();
      $('.btn-soldout').show();
      // alertError(response.responseJSON.message)
    });
  }
});
// 購物車數量加減
$(document).on('click', '.btn-num-control', function(event) {
  var action = $(this).data('action');
  var numField = $(this).siblings('input');
  var num = parseInt(numField.val());
  if (action == 'less') {
    if (num > 1) {
      numField.val(num-1);
    } else {
      numField.val(1);
    }
  } else if (action == 'add') {
    if (num>0) {
      numField.val(num+1);
    } else{
      numField.val(1);
    }
  }
  numField.change();
});
// 加入購物車
$('.btn-add-cart').click(function(event) {
  var price = $('[name=price]').val();
  var qty = parseInt($('[name=qty]').val());
  // console.log(price, qty);
  if (!qty || qty < 1) {
    alertError(App.text.please_input_qty)
    return false;
  }
  $.post(
    App.homeUrl+'/api/cart/add',
    {
      _token: App.csrfToken,
      price: price,
      qty: qty
    },
    function(response){
      // $('select[name^=option]').val('');
      // $('input[name^=option]').prop('checked', '');
      // $('[name=qty]').val(1);

      updateTopCart(response.cart, response.topCartLayout)
      alertSuccess(response.message);
    }
  ).fail(function(response) {
    alertError(response.responseJSON.message)
  });
});
// 刪除購物車商品
$(document).on('click', '.btn-del-item', function(event) {
  var props = $(this).data('props');
  $.post(
    App.homeUrl+'/api/cart/delete',
    {
      _token: App.csrfToken,
      props: props
    },
    function(response){
      // console.log(data);
      updateCart(response.cart, response.cartLayout)
      updateTopCart(response.cart, response.topCartLayout)
    }
  );
  return false;
});
function alertSuccess(txt) {
  swal({
    title: txt,
    icon: "success",
    button: App.text.ok
  });
}
function alertError(txt) {
  swal({
    title: txt,
    icon: "error",
    button: App.text.close
  });
}
// 修改購物車商品數量
$(document).on('change', '.cart-qty', function(event) {
  var t = $(this);
  var props = t.data('props');
  var qty = parseInt(t.val());
  if (!qty || qty < 1) {
    alertError(App.text.please_input_qty)
    return false;
  }
  $.post(
    App.homeUrl+'/api/cart/update_qty',
    {
      _token: App.csrfToken,
      props: props,
      qty: qty,
    },
    function(response){
      // console.log(data);
      updateCart(response.cart, response.cartLayout)
      updateTopCart(response.cart, response.topCartLayout)
    }
  ).fail(function(response) {
    t.parents('td').addClass('has-error')
    // console.log(t)
    alertError(response.responseJSON.message)
  });
});
// 更新優惠代碼
$('.coupon-apply').click(function(event) {
  $.post(
    App.homeUrl+'/api/cart/update_coupon',
    {
      _token: App.csrfToken,
      coupon_code: $('#coupon').val(),
    },
    function(response, status){
      // console.log(response);
      updateCart(response.cart, response.cartLayout)
      // updateTopCart(data)
      alertSuccess(response.message)
    }
  ).fail(function(response) {
    $('#coupon').val('');
    updateCart(response.responseJSON.cart)
    alertError(response.responseJSON.message)
  });
  return false;
});
// 使否使用紅利
$('input[name=use_bonus]').change(function(event) {
  // console.log($(this).is(':checked'))
  $.post(
    App.homeUrl+'/api/cart/update_bonus',
    {
      _token: App.csrfToken,
      use_bonus: $(this).is(':checked')?1:0,
    },
    function(response, status){
      // console.log(response);
      updateCart(response.cart, response.cartLayout)
      // updateTopCart(data)
    }
  ).fail(function(response) {
    // $('#coupon').val('');
    updateCart(response.responseJSON.cart)
    alertError(response.responseJSON.message)
  });
});
// 更新運費
// $('[name=shipping]').change(function() {
//   var shipping_id = $('[name=shipping]:checked').val();
//   $.post(
//     App.homeUrl+'/api/cart/update_shipping',
//     {
//       _token: App.csrfToken,
//       shipping_id: shipping_id,
//     },
//     function(response, status){
//       // console.log(response);
//       updateCart(response.cart, response.cartLayout)
//       updatePaymentBox(response.payments);
//       // updateTopCart(data)
//     }
//   );
// });
// 更新付款方式
$(document).on('click', '[name=payment]', function() {
  var payment_id = $('[name=payment]:checked').val();
  $.post(
    App.homeUrl+'/api/cart/update_payment',
    {
      _token: App.csrfToken,
      payment_id: payment_id,
    },
    function(response){
    }
  );
});
// 更新Header內的購物車HTML
function updateTopCart(cart, layout) {
  // console.log(cart)
  var cartHtml = '';
  var optionsCount = 0
  if (! $.isEmptyObject(cart)) {
  //   cartHtml += '<ul class="list top-cart-list">'
  //   $.each(cart.items, function(key, item) {
  //     cartHtml += '<li class="item">'
  //     cartHtml += '<a href="'+App.routes.product+'/'+item.product.slug+'" class="box">'
  //     cartHtml += '<span class="pic"><img src="/images/cart_pic.jpg" alt=""></span>'
  //     cartHtml += '<span class="txt">'
  //     cartHtml += '<span class="name">'+item.product.title+'</span>'
  //     cartHtml += '<span class="info">'
  //     cartHtml += item.qty+' * '+item.options+' - '+showPrice(item.price)
  //     cartHtml += '</span>'
  //     cartHtml += '</span>'
  //     cartHtml += '</a>'
  //     // cartHtml += '<button type="button" class="btn btn-del-item" data-props="'+key+'"><i class="fa fa-times"></i></button>'
  //     cartHtml += '</li>'
  //   });
  //   cartHtml += '</ul>'
    $('.toggle-top-cart .qty').html(cart.totalQty).addClass('c2')
  //   $('.top-cart-total-info').removeClass('hide')
  //   $('.top-cart .total').html(showPrice(cart.totalPrice, 'span'))
  } else {
  //   cartHtml += '<ul class="list top-cart-list">'
  //   cartHtml += '<li class="item">'
  //   cartHtml += '<div class="no-data">'+App.text.cart_no_item+'</div>'
  //   cartHtml += '</li>'
  //   cartHtml += '</ul>'
    $('.toggle-top-cart .qty').html('0').removeClass('c2');
  //   $('.top-cart-total-info').addClass('hide')
  }
  cartHtml += layout;
  $('.top-cart-layout-holder').html(cartHtml)
}
// 更新購物車HTML
function updateCart(cart, layout) {
  var cartHtml = '';
  cartHtml += layout;
  // console.log(cart);
  // if (! $.isEmptyObject(cart)) {
  //   $.each(cart.items, function(key, item) {
  //     cartHtml += '<tr>'
  //     cartHtml += '<td><a href="'+App.routes.product+'/'+item.product.slug+'">'+ item.product.title +'</a></td>'
  //     cartHtml += '<td data-title="'+App.text.spec+'：">'+item.options+'</td>'
  //     cartHtml += '<td data-title="'+App.text.qty+'：">'
  //     cartHtml += '<div class="input-num-group">'
  //     cartHtml += '<button class="btn btn-num-control" data-action="less">-</button>'
  //     cartHtml += '<input type="text" name="qty" id="qty" value="'+item.qty+'" class="form-control cart-qty" data-props="'+key+'">'
  //     cartHtml += '<button class="btn btn-num-control" data-action="add">+</button>'
  //     cartHtml += '</div>'
  //     cartHtml += '</td>'
  //     cartHtml += '<td data-title="'+App.text.price+'：">'+showPrice(item.price)+'</td>'
  //     cartHtml += '<td data-title="'+App.text.total+'：">'+showPrice(item.total)+'</td>'
  //     cartHtml += '<td class="btn-holder"><button type="button" class="btn btn-del-item" data-props="'+key+'">✖</button></td>'
  //     cartHtml += '</tr>'
  //   });
  //   $('.cart-holder').html(cartHtml);
  //   $('#total_price').text(showPrice(cart.totalPrice));
  //   $('.bonus_price').text(showPrice(cart.bonusPrice));
  //   if (App.signedIn && cart.bonus==1) {
  //     $('#bonus').show();
  //   } else {
  //     $('#bonus').hide();
  //   }
  //   $('#coupon_price').text(showPrice(cart.couponPrice));
  //   $('#shipping_price').text(showPrice(cart.shippingPrice));
  //   $('#sum_price').text(showPrice(cart.sumPrice));
  // } else {
  //   cartHtml += '<div class="cart-no-item">'
  //   cartHtml += '<div class="txt">'+App.text.cart_no_item+'</div>'
  //   cartHtml += '<div class="btn-box">'
  //   cartHtml += '<a href="'+App.routes.product+'" class="btn btn-primary"><span>'+App.text.continue_shopping+'</span></a>'
  //   cartHtml += '</div>'
  //   cartHtml += '</div>'
  // }
  $('#cart').html(cartHtml);
}
function updatePaymentBox(payments) {
  var paymentHtml = '';
  if (payments) {
    $.each(payments, function(key, payment) {
      paymentHtml += '<label><input type="radio" name="payment" value="'+payment.id+'">'+payment.title+'</label> ';
    });
  } else {
    paymentHtml += '<h3>請先選擇配送方式</h3>'
  }
  $('#payment-box').html(paymentHtml);
}
// 結帳頁收件人資料同購買人資料
$('[name=same]').change(function(event) {
  var isSame = $(this).is(':checked');
  if (isSame) {
    $('[name=get_first_name]').val($('[name=first_name]').val());
    $('[name=get_last_name]').val($('[name=last_name]').val());
    // $('[name=get_sex][value='+$('[name=sex]:checked').val()+']').prop('checked', true);
    $('[name=get_phone]').val($('[name=phone]').val());
    // $('[name=get_company]').val($('[name=company]').val());
    $('[name=get_email]').val($('[name=email]').val());
    // $('[name=get_country]').val($('[name=country]').val());
    // $('[name=get_city]').val($('[name=city]').val());
    // $('[name=get_zip_code]').val($('[name=zip_code]').val());
    // $('[name=get_address]').val($('[name=address]').val());
  }
});

// 三聯式發票出現抬頭跟統一編號的欄位
$('input[name=invoice]').change(function(event) {
  var invoice_val = $('input[name=invoice]:checked').val();
  if (invoice_val == 3) {
    $('.ein-box').slideDown('fast');
  } else {
    $('.ein-box').slideUp('fast');
  }
});
$('.order-cancel').click(function(event) {
  event.preventDefault();
  var cancelLink = $(this).attr('href');
  // if(confirm("確定要取消訂單嗎?")==false) return false;
  swal({
    title: "確定要取消訂單嗎?",
    icon: "warning",
    buttons: true,
    dangerMode: true,
  })
  .then((willDelete) => {
    if (willDelete) {
      $.post(
        cancelLink,
        {
          _token: App.csrfToken,
        },
        function(response){
          swal({
            title: response.message,
            text: response.ordernumber,
            icon: "success",
            button: App.text.ok
          }).then((value) => {
            location.reload();
          });
        }
      ).fail(function(response) {
        alertError(response.responseJSON.message)
      });
    }
  });
});
/**
 * number_format
 * @param number 传进来的数,
 * @param bit 保留的小数位,默认保留两位小数,
 * @param sign 为整数位间隔符号,默认为空格
 * @param gapnum 为整数位每几位间隔,默认为3位一隔
 * @type arguments的作用：arguments[0] == number(之一)
*/
function number_format(number,bit,sign,gapnum){
    //设置接收参数的默认值
    var bit    = arguments[1] ? arguments[1] : 2 ;
    var sign   = arguments[2] ? arguments[2] : ' ' ;
    var gapnum = arguments[3] ? arguments[3] : 3 ;
    var str    = '' ;

    var number     = parseFloat(number).toFixed(bit);//格式化
    var realnum    = number.split('.')[0];//整数位(使用小数点分割整数和小数部分)
    var decimal    = number.split('.')[1];//小数位
    var realnumarr = realnum.split('');//将整数位逐位放进数组 ["1", "2", "3", "4", "5", "6"]

    //把整数部分从右往左拼接，每bit位添加一个sign符号
    for(var i=1;i<=realnumarr.length;i++){
        str = realnumarr[realnumarr.length-i] + str ;
        if(i%gapnum == 0){
            str = sign+str;//每隔gapnum位前面加指定符号
        }
    }

    //当遇到 gapnum 的倍数的时候，会出现比如 ",123",这种情况，所以要去掉最前面的 sign
    str = (realnum.length%gapnum==0) ? str.substr(1) : str;
    //重新拼接实数部分和小数位
    realnum = str+'.'+decimal;
    return realnum;
}
function showPrice(price, tag='') {
  // console.log(number_format(price, 2));
  if (tag) {
    var currency = '<'+tag+'>USD</'+tag+'>';
  } else {
    var currency = 'USD ';
  }
  return currency + number_format(price, 2);
}



// WEBPACK FOOTER //
// ./resources/assets/js/cart.js